import CessationReasonsView from "../CessationReasonsView.vue";
import CessationReasonList   from "../Pages/CessationReasonList.vue";
import CessationReasonEditor from "../Pages/CessationReasonEditor.vue";

const routes = [
  {
    path: "/mantenimiento/motivos-cese",
    component: CessationReasonsView,
    children: [
      {
        path: "",
        name: "cessation-reason-list",
        component: CessationReasonList,
      },
      {
        path: "crear",
        name: "cessation-reason-create",
        component: CessationReasonEditor,
      },
      {
        path: ":id/editar",
        name: "cessation-reason-edit",
        component: CessationReasonEditor,
      },
    ],
  },
];

export default routes;
